import { PDFila } from './PDFila';

export class PDTabla {
    columnas: string;
    filas: PDFila[];
    nombre: string;
    ubicacion: string;
    nuevasFilas: string;


}
